import { Button } from '@storeblocks/button';
import { type FC, useState } from 'react';

import { Source } from '@/api/contactUsForm/contactUsFormApi';
import { WithGap } from '@/components/WithGap';
import { useTexts } from '@/hooks/useTexts';
import { TrackingElement, useGetTrackId } from '@/tracking';

import { ConnectSurface } from '../Pretzel/ConnectSurface';
import { ContactFormSuccess } from './ContactFormSuccess';
import { Form } from './Form';

interface Props {
  source: Source;
}

export const ContactForm: FC<Props> = ({ source }) => {
  const texts = useTexts();
  const getTrackId = useGetTrackId();

  const [isOpen, setIsOpen] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);

  return (
    <WithGap gap="8">
      <div>
        {/* Button to open and close the form */}
        <Button
          variant="subtle"
          iconRight={isOpen ? 'chevron_up' : 'chevron_down'}
          onClick={() => setIsOpen((state) => !state)}
          data-test="toggle-contact-us-form"
          data-trackid={getTrackId(
            'toggle-contact-us-form',
            TrackingElement.Button,
          )}
        >
          {texts.pages.contactUs.needHelp.title}
        </Button>
      </div>

      {isOpen && (
        <ConnectSurface data-test="contact-form-content">
          {isSubmitted ? (
            // The contact form has been successfully submitted.
            // Render a success message.
            <ContactFormSuccess
              onClose={() => setIsOpen(false)}
              onReset={() => setIsSubmitted(false)}
            />
          ) : (
            // The contact form has not been submitted yet.
            // Render the contact us form.
            <Form
              source={source}
              onClose={() => setIsOpen(false)}
              onSuccessfulSubmit={() => setIsSubmitted(true)}
            />
          )}
        </ConnectSurface>
      )}
    </WithGap>
  );
};
